<template>
  <div>
    <div id="map-div" :class="cclass" :style="wStyle">
      <div id="map_canvas" class="center-block full" :style="mcStyle" :class="mcClass"> </div>
    </div>
  </div>
</template>

<script>
// map_canvas must have height and width defined
// mcClass default: 100% everything half : 50% all
import logopemex from '../../assets/imgs/logos/logo_pemex_original.png'
import * as R from 'ramda';
export default {
  props: ['cclass', 'mcStyle', 'wStyle', 'mcClass', 'markerList'],
  data() {
    return {
      map: null,
      markers: [],
      markersMap: [],
      infowindow: undefined,
    }
  },
  methods: {
    imgUrl(url) {
      return require(`imgs/icons/${url}`)
    },
    leakMarkerListener(marker, d) {
      marker.addListener('click', () => {
        this.$emit('marker-clicked', marker);
        this.map.panTo(marker.getPosition())        
        google.maps.event.addListenerOnce(this.map, 'idle', () => { 
          this.map.setOptions({
            center: marker.getPosition(),
            zoom: 35
          })
        })
        this.infowindow.setContent(
          '<h5 style="color: var(--btn-default); font-weight:800">Alarma de fuga</h5>' +
          `<p style="color: var(--btn-default); font-size: 13px; font-weight: 400;"> ${d.estado} - ${d.municipio} <br> KM ${d.km}</p>` +
          `<p style="font-size:12px;margin-top:0.1em;margin-bottom:0em;"><span style="font-weight:800">Latitud:</span> ${d.lat}</p>` +
          `<p style="font-size:12px;margin-top:0.1em;margin-bottom:0em;"><span style="font-weight:800">Longitud:</span> ${d.lng}</p>` +
          `<p style="font-size:12px;margin-top:0.1em;margin-bottom:0em;"><span style="font-weight:800">Fecha:</span> ${d.fecha}</p> <br>` +
          `<p style="font-size:12px;margin-top:0.1em;margin-bottom:0em;"><span style="font-weight:800">${d.isMP ? 'Eventos' : 'Tipo'}:</span> ${d.isMP ? d.tipo : (d.tipo === 1 ? 'Apertura' : 'Cierre')}</p> <br>`
        )
        this.infowindow.open(this.map, marker)  
      })
    },
    fillMark() {
      let ducts = this.$store.getters.GET_HOME_DUCTOS_TABLE
      if(!ducts) {
        return
      }
      Object.keys(ducts).forEach(idSection => {
        let section = ducts[idSection]
        // var pathData = []
        Object.keys(section.sites).forEach(idSite => {
          let site = section.sites[idSite]
          let imgSrc = 'place_red.gif'

          if(!site.hasFailure()) {
            imgSrc = 'place_green.png'
          }
          
          if(site.battery < 12 || site.hasPressueAlarm()) {
            imgSrc = 'place_yellow.png'
          }
  
          if(site.isOffline() || site.cabinet_door === 1 || site.gps === 0 || site.site_door === 1 || site.pressure === 0){
            imgSrc = 'place_red.gif'
          }

          let img = new google.maps.MarkerImage(
            this.imgUrl(imgSrc),
          )
     

          let marker = this.getMarker(section.id, site.id)
          if (!marker) {
              marker = new google.maps.Marker({
              position: new google.maps.LatLng(
                site.lat,
                site.lon
              ),
              map: this.map,
              icon: img,
            })
            this.markerListener(marker, section, site)
            this.markersMap.push(marker)
          } else {
            marker.setIcon(img)
          }
        })
      })
    },
    markerListener(marker, section, site, imgIcon = 'place_green.png') {
      let fallaMsg = ''
      marker.addListener('click', () => {
        this.$emit('marker-clicked', site);
        (site._battery <= 10) ? fallaMsg = 'Batería baja' : (site._cabinet_door === 1) ? fallaMsg = 'Fallo en la puerta' : (site._gps === 0) ? fallaMsg = 'Fallo en el gps' : (site._site_door === 1) ? fallaMsg = 'Fallo en la puerta del site' : fallaMsg = ''
        if(fallaMsg !== ''){
          fallaMsg = `${fallaMsg}</p>`
        }

        this.infowindow.setContent(
          '<img width="116" height="32" src="' + logopemex + '"> ' +
          '<h5> ' +
            section.name +
            ' </h5> <br>' +
            '<h6 style="color: var(--btn-default)">' +
            site.name +
            ' </h6>' +
            '<p style="font-size:12px;">' + site.lat + ' ' + site.lon + '<br>' + site.city + '<br> KM ' + site.km + ' <br> Carga de batería ' + site.battery + ' <br> Presión ' + site.pressure + ' <br> Online ' + site.online + '</p>' + ' <br> Último evento ' + site.insertTimestamp + '</p>' + 
            '<p class="pull-right" style="color: red; font-weight: 800;">' + fallaMsg + '</p>'
        )
        this.infowindow.open(this.map, marker)
      })
    },
    fillMap(data, ducto){
      // add markers
      if(!this.infowindow) {
        this.infowindow = new google.maps.InfoWindow({
            size: new google.maps.Size(150, 50),
            maxWidth: 300
        })
      }

      if(this.markers.length !== 0) {
        this.markers.forEach(mar => {
          mar.setMap(null)
        })
      }
      this.markers = []
      var bounds = new google.maps.LatLngBounds()
      data.forEach(d => {
        if(d.lat === 0 && d.lng === 0) {
          return
        }
        
        let marker = new google.maps.Marker({
            position: new google.maps.LatLng(d.lat, d.lng),
            draggable: false,
            map: this.map,
            customInfo: d.id
        })
        let img = new google.maps.MarkerImage(
          this.imgUrl('leak_green.png'),
        )
        marker.setIcon(img)
        bounds.extend(marker.getPosition())

        this.markers.push(marker)
        this.leakMarkerListener(marker, d)
      })
      this.map.setZoom(7)
      this.map.fitBounds(bounds)
    },
    drawDucts() {
      const data = this.$store.getters.GET_ROUTES
      const sections = this.$store.getters.allowedSections
      for(let id in data) {
        if(!R.contains(id, sections)) {
          continue;
        }
        const route = data[id]
        var linePath = new google.maps.Polyline({
          path: route,
          geodesic: false,
          strokeColor: '#FF0000',
          strokeWeight: 5,
          strokeOpacity: 1.0
        })
        linePath.setMap(this.map)
      }
    },          
    getMarker(section, site) {
      let result
      this.markers.some(marker => {
        if (
          marker.customInfo &&
          marker.customInfo.section === section &&
          marker.customInfo.site === site
        ) {
          result = marker
          return true
        }
        return false
      })
      return result
    },
    zoom(mark) { // called from parent
      let result = null
      let id = mark.id
      this.markers.some(marker => {
        if (
          marker.customInfo &&
          marker.customInfo === id
        ) {
          result = marker
          return true
        }
        return false
      })
      if(!result) {
        return
      }
      google.maps.event.trigger(result, 'click')
    },
    startGoogleMaps() {
      var myOptions = {
        zoom: 5,
        center: { lat: 23.878211, lng: -102.770344 },
        mapTypeControl: true,
      }

      this.map = new google.maps.Map(document.getElementById('map_canvas'), myOptions)

      google.maps.event.addListenerOnce(this.map, 'idle', () => {
        let data = this.$store.getters.GET_ROUTES
        let update = !data || Object.keys(data).length <= 0
        if(update) {
          this.$store.dispatch('LOAD_PIPELINE_SHAPES')
          this.$store.watch(
            (state) => {
              return state.routes
            }, 
            () => {
              this.drawDucts()
            }, {
              immediate: true
          })
        } else {
          this.drawDucts()
        }

        data = this.$store.getters.GET_HOME_DUCTOS_TABLE
        if(!data) {
          console.log('polling ducts');
          this.$store.dispatch('LOAD_DUCTOS').then((data) => {
            this.fillMark()
          })
        }
      })
    }
  },
  mounted() {
    this.startGoogleMaps()
  }
}
</script>

<style lang="scss" scoped>
@import '~varmix';

#map-div {
  // position: absolute;
  z-index: -10;
  margin: 0;
  width: 100%;
}

#map_canvas {
  margin: 0;
  padding: 0;
  position: unset;
}

.full {
  height: 100vh;
  width: 100vw;
}

.half {
  height: 50vh;
  width: 50vw;
  @include tablet {
    width: 100vw !important;
  }
}

.modal {
  height: 500px;
  width: 600px;
  @include celphone {
    height: 90vh;
    width: auto;
  }
}
</style>




// WEBPACK FOOTER //
// Map.vue?5c48f626